import { useContext } from "react"
import { useHistory } from "react-router-dom"
import { FiEye } from "react-icons/fi"
import { format } from "date-fns"
import Spinner from "../../../../components/Spinner"
import Table from "../../../../components/Table"
import { GlobalContext } from "../../../../contexts/GlobalContext"

export function ListaProjetosAAceitar({ projetos }) {
	const history = useHistory()

	const { user } = useContext(GlobalContext)

	if(!projetos) {
		return <Spinner />
	}

	return (
		<div className="flex flex-col gap-4 items-center justify-center">
			<h1 style={{ fontSize: 18 }}>Aceites pendentes</h1>

			<Table
				headers={[
					{ name: 'nome', value: 'Projeto' },
					{ name: 'prazo', value: 'Prazo para aceite', centered: true }
				]}
				data={projetos.map(proj => {
					const dataExpiracao = new Date(proj.projeto_pessoas.find(pp => pp.pessoa.id === user.pessoa.id).expiracao_aceite)
					
					return {
						id: proj.id,
						nome: proj.nome,
						prazo: format(dataExpiracao, 'dd/MM/yyyy')
					}
				})}
				actions={[
					{
						action: item => {
							history.push(`/projeto/${item.id}`)
						},
						icon: FiEye,
						iconSize: 16,
						name: 'Abrir'
					}
				]}
				emptyLabel="Nenhum projeto nesta lista"
			/>
		</div>
	)
}